var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 156,
    viewBox: "0 0 121 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.306 74.6321C113.306 89.8294 107.07 103.528 97.0715 113.375C87.2881 123.114 73.7419 129 58.798 129C43.9617 129 30.4154 123.007 20.5245 113.375C10.5261 103.528 4.29053 89.8294 4.29053 74.6321C4.29053 44.5585 28.6953 20.2642 58.798 20.2642C88.9008 20.2642 113.306 44.6655 113.306 74.6321Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.575 38.9932C111.009 38.9932 112.983 37.0286 112.983 34.6052C112.983 32.1818 111.009 30.2173 108.575 30.2173C106.14 30.2173 104.167 32.1818 104.167 34.6052C104.167 37.0286 106.14 38.9932 108.575 38.9932Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.025 21.8695C116.688 21.8695 118.036 20.5279 118.036 18.8729C118.036 17.2179 116.688 15.8762 115.025 15.8762C113.363 15.8762 112.015 17.2179 112.015 18.8729C112.015 20.5279 113.363 21.8695 115.025 21.8695Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01028 38.8861C7.6728 38.8861 9.02055 37.5445 9.02055 35.8895C9.02055 34.2345 7.6728 32.8928 6.01028 32.8928C4.34775 32.8928 3 34.2345 3 35.8895C3 37.5445 4.34775 38.8861 6.01028 38.8861Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8948_38934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6402 49.7075L98.5003 118.631C98.5003 120.985 96.5651 122.805 94.1999 122.805H26.6837C24.3185 122.805 22.3833 120.878 22.3833 118.631V30.0152C22.3833 27.6607 24.3185 25.8413 26.6837 25.8413H75.6007L97.6402 49.7075Z",
    fill: "url(#paint0_linear_8948_38934)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5387 40.2892H33.779C33.0264 40.2892 32.3813 39.6471 32.3813 38.8979C32.3813 38.1487 33.0264 37.5066 33.779 37.5066H57.5387C58.2912 37.5066 58.9363 38.1487 58.9363 38.8979C58.9363 39.6471 58.2912 40.2892 57.5387 40.2892Z",
    fill: "#D5DDEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2501 47.995H33.779C33.0264 47.995 32.3813 47.3529 32.3813 46.6037C32.3813 45.8545 33.0264 45.2124 33.779 45.2124H46.1426C46.8952 45.2124 47.5402 45.8545 47.5402 46.6037C47.5402 47.3529 46.8952 47.995 46.2501 47.995Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6006 25.8413V44.8915C75.6006 47.5671 77.9658 49.7075 80.6535 49.7075H97.6401",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0612 40.0379L48.1696 22.1008L69.1519 24.5067L61.8263 36.1962L67.5005 40.7091L55.2844 67.3083L55.965 46.7153L43.0612 40.0379Z",
    fill: "#EAEEF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5949 19.4782L43.5293 13.386",
    stroke: "#A2ABBE",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4374 16.4323L58.915 1",
    stroke: "#A2ABBE",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1584 19.622L74.6484 5.59912",
    stroke: "#A2ABBE",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0805 96.6564C45.6289 96.6564 45.2676 96.4766 44.9063 96.2069C44.2741 95.5775 44.2741 94.4985 44.9063 93.8691C49.0611 89.823 54.5708 87.5752 60.4417 87.5752C66.3126 87.5752 71.8223 89.823 75.9771 93.8691C76.6093 94.4985 76.6093 95.5775 75.9771 96.2069C75.3448 96.8363 74.261 96.8363 73.6287 96.2069C70.1062 92.7003 65.4094 90.8121 60.4417 90.8121C55.474 90.8121 50.7772 92.7003 47.2547 96.2069C46.8934 96.4766 46.5321 96.6564 46.0805 96.6564Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7708 72.5598L53.9385 70.4018C54.5708 69.7724 54.5708 68.6935 53.9385 68.0641C53.3063 67.4347 52.2224 67.4347 51.5901 68.0641L49.4224 70.222L47.2547 68.0641C46.6224 67.4347 45.5386 67.4347 44.9063 68.0641C44.2741 68.6935 44.2741 69.7724 44.9063 70.4018L47.074 72.5598L44.9063 74.7177C44.2741 75.3471 44.2741 76.426 44.9063 77.0554C45.2676 77.4151 45.6289 77.505 46.0805 77.505C46.5321 77.505 46.8934 77.3252 47.2547 77.0554L49.4224 74.8975L51.5901 77.0554C51.9514 77.4151 52.3127 77.505 52.7643 77.505C53.2159 77.505 53.5772 77.3252 53.9385 77.0554C54.5708 76.426 54.5708 75.3471 53.9385 74.7177L51.7708 72.5598Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.719 72.5598L75.8868 70.4018C76.519 69.7724 76.519 68.6935 75.8868 68.0641C75.2545 67.4347 74.1706 67.4347 73.5384 68.0641L71.3707 70.222L69.2029 68.0641C68.5707 67.4347 67.4868 67.4347 66.8546 68.0641C66.2223 68.6935 66.2223 69.7724 66.8546 70.4018L69.0223 72.5598L66.8546 74.7177C66.2223 75.3471 66.2223 76.426 66.8546 77.0554C67.2158 77.4151 67.5771 77.505 68.0287 77.505C68.4804 77.505 68.8416 77.3252 69.2029 77.0554L71.3707 74.8975L73.5384 77.0554C73.8997 77.4151 74.261 77.505 74.7126 77.505C75.1642 77.505 75.5255 77.3252 75.8868 77.0554C76.519 76.426 76.519 75.3471 75.8868 74.7177L73.719 72.5598Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8948_38934",
    x: 0.383301,
    y: 14.8413,
    width: 120.117,
    height: 140.963,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8948_38934"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8948_38934",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8948_38934",
    x1: 60.417,
    y1: 23.5985,
    x2: 60.417,
    y2: 123.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyItem);
export default __webpack_public_path__ + "static/media/EmptyItem.57b5c24cea209afadca40d078ccd705d.svg";
export { ForwardRef as ReactComponent };